<p>
  <button (click)="logout()" class="basic-btn">Logout</button>
  Please Login to access this page.
</p>
